<template>
	<span
		:class="avatarClass"
		@click="handleAction"
	>
		<span
			v-if="imageUrl && !isLoadError"
			class="kk-avatar__content-container kk-avatar__content-container--img"
		>
			<img
				:src="imageUrl"
				alt=""
				@error="handleError"
			>
		</span>
		<span
			v-else-if="showIconName"
			class="kk-avatar__content-container kk-avatar__content-container--icon"
		>
			<KkIconBase
				class="kk-avatar__icon"
				:name="showIconName"
			/>
		</span>
		<span
			v-else
			class="kk-avatar__content-container kk-avatar__content-container--text"
		>
			{{ formattedText }}
		</span>
		<span
			v-if="isShowActionIconName"
			:class="iconContainerClass"
		>
			<KkIcon
				class="kk-avatar__action-icon"
				:name="actionIconName"
				:size="actionIconSize"
			/>
		</span>
		<KkBadge
			v-if="isShowBadge"
			class="kk-avatar__badge"
			:dot-size="BADGE_DOT_SIZE_MAP[size]"
		/>
	</span>
</template>

<script>
import KkIcon from '../../KkIcon';
import KkBadge from '../../KkBadge';
import KkIconBase from '../../KkIconBase';

export const KK_AVATAR_SIZE_LIST = [
	'xs',
	'sm',
	'md',
	'lg',
	'xl',
	'2xl',
];

export const KK_AVATAR_THEME_LIST = [
	'cyan',
	'blue',
	'amber',
	'red',
	'neutral',
];

const BADGE_DOT_SIZE_MAP = {
	'xs': 'md',
	'sm': 'lg',
	'md': 'lg',
	'lg': 'xl',
	'xl': 'xl',
	'2xl': 'xl',
};

export const POSITION_SCALE_RULES = [0, 1, 2, 3];

export default {
	name: 'KkAvatar',
	components: {
		KkBadge,
		KkIconBase,
		KkIcon,
	},
	props: {
		size: {
			type: String,
			default: 'md',
			validator: (val) => KK_AVATAR_SIZE_LIST.indexOf(val) !== -1,
		},
		theme: {
			type: String,
			default: null,
			validator: (val) => !val || KK_AVATAR_THEME_LIST.indexOf(val) !== -1,
		},
		imageUrl: {
			type: String,
			default: null,
		},
		iconName: {
			type: String,
			default: null,
		},
		text: {
			type: String,
			default: null,
		},
		actionIconName: {
			type: String,
			default: null,
		},
		actionIconSize: {
			type: String,
			default: 'sm',
		},
		isShowBadge: {
			type: Boolean,
			default: false,
		},
		isEnableInteraction: {
			type: Boolean,
			default: false,
		},
		isShowIconbackground: {
			type: Boolean,
			default: true,
		},
		horizontalPosition: {
			type: Number,
			default: 0,
			validator: (val) => POSITION_SCALE_RULES.indexOf(val) !== -1,
		},
		verticalPosition: {
			type: Number,
			default: 0,
			validator: (val) => POSITION_SCALE_RULES.indexOf(val) !== -1,
		},
	},
	data() {
		return {
			isLoadError: false,
			BADGE_DOT_SIZE_MAP,
		};
	},
	computed: {
		avatarClass() {
			const classList = ['kk-avatar', `kk-avatar--${ this.size }`];
			if (this.theme) {
				classList.push(`kk-avatar--${ this.theme }`);
			}
			if (this.isEnableInteraction && this.actionIconName) {
				classList.push('kk-avatar--action');
			}

			return classList;
		},
		iconContainerClass() {
			return [
				'kk-avatar__action-icon-container',
				`kk-avatar__action-icon-container--position-x-${ this.horizontalPosition }`,
				`kk-avatar__action-icon-container--position-y-${ this.verticalPosition }`,
				this.isShowIconbackground && 'kk-avatar__action-icon-container--bg-show'
			];
		},
		formattedText() {
			return this.text?.length ? this.text[0] : '';
		},
		showIconName() {
			return this.iconName || '';
		},
		isShowActionIconName() {
			return this.actionIconName;
		},
	},
	watch: {
		imageUrl() {
			this.isLoadError = false;
		},
	},
	methods: {
		handleError() {
			this.isLoadError = true;
		},
		handleAction() {
			if (this.isEnableInteraction) {
				this.$emit('click');
			}
		},
	},
};
</script>
